import { Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { SnackBarMessage } from 'src/app/core/services/toast.service';

@Component({
  imports: [MatIconModule],
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss'
})
export class ToastComponent {
  readonly data: { messages: SnackBarMessage[] } = inject(MAT_SNACK_BAR_DATA);
}
